import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager, Variables } from 'core/index';
import { getWhitelabelConfig } from 'core/whitelabel';

import { ProjectConnManager } from 'apps/project/connManager';
import { StoryConnManager } from 'apps/story/main/appManager';
import { InitiativeConnManager } from 'apps/initiative/connManager';
import { ProfileConnManager } from 'apps/profile/main/connManager';
import {
  FeaturedProjectsQuery,
  FeaturedInitiativesQuery,
} from 'apps/home/featured/gql';

import {
  WhiteLabelProjectsQuery,
  WhiteLabelStoriesQuery,
  WhiteLabelProfilesQuery,
} from 'apps/microSite/gql';

export class SinglePageMicroSiteManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    const whitelabelConfig = getWhitelabelConfig();
    this.variables = new Variables({
      featuredProjectsCursor: () => this.featuredProjectsConn.endCursor,
      featuredProjectsSortBy: () => this.featuredProjectsConn.sortBy,
      featuredProjectsCount: () =>
        this.featuredProjectsConn.variables.batchSize,
      wlProjectsCursor: () => this.projectsConn.endCursor,
      wlProjectsSortBy: () => this.projectsConn.sortBy,
      wlProjectsCount: () => this.projectsConn.variables.batchSize,
      initiativesCursor: () => this.initiativesConn.endCursor,
      initiativesSortBy: () => this.initiativesConn.sortBy,
      initiativesCount: () => this.initiativesConn.variables.batchSize,
      profilesCursor: () => this.profilesConn.endCursor,
      profilesSortBy: () => this.profilesConn.sortBy,
      profilesCount: () => this.profilesConn.variables.batchSize,
    });
    whitelabelConfig.pages.home.homeSections.forEach(section => {
      if (section === 'featuredProjects') {
        this.featuredProjectsConn = new ProjectConnManager(this, {
          contains: [
            'featured_in',
            whitelabelConfig.pages.home.featuredProjects.featuredIn,
          ],
          sortBy: 'discover_recent',
          sortOptions: [
            ['discover_recent', i18next.t('Recent')],
            ['followers', i18next.t('Followers')],
            ['contributions', i18next.t('Contributions')],
          ],
          initialBatchSize: 6,
          loadMoreQuery: FeaturedProjectsQuery,
        });
      }
      if (section === 'projects') {
        this.projectsConn = new ProjectConnManager(this, {
          filterBy: [['whitelabel', whitelabelConfig.id]],
          sortBy: 'discover_recent',
          sortOptions: [
            ['discover_recent', i18next.t('Recent')],
            ['followers', i18next.t('Followers')],
            ['contributions', i18next.t('Contributions')],
          ],
          initialBatchSize: 6,
          loadMoreQuery: WhiteLabelProjectsQuery,
        });
      }
      if (section === 'stories') {
        this.storiesConn = new StoryConnManager(this, {
          filterBy: [['whitelabel', whitelabelConfig.id]],
          sortBy: 'discover_recent',
          sortOptions: [
            ['discover_recent', i18next.t('Recent')],
            ['followers', i18next.t('Followers')],
            ['contributions', i18next.t('Contributions')],
          ],
          initialBatchSize: 6,
          loadMoreQuery: WhiteLabelStoriesQuery,
        });
      }
      if (section === 'organisations') {
        this.initiativesConn = new InitiativeConnManager(this, {
          filterBy: [['whitelabel', whitelabelConfig.id]],
          sortBy: 'followers',
          sortOptions: [
            ['followers', i18next.t('Followers')],
            ['recent', i18next.t('Recent')],
            ['name', i18next.t('Name')],
          ],
          loadMoreQuery: FeaturedInitiativesQuery,
          initialBatchSize: 6,
        });
      }
      if (section === 'profiles') {
        this.profilesConn = new ProfileConnManager(this, {
          loadMoreQuery: WhiteLabelProfilesQuery,
          filterBy: [['whitelabel', whitelabelConfig.id]],
          sortBy: 'recent',
          initialBatchSize: 16,
          batchSize: 16,
          sortOptions: [
            ['recent', i18next.t('Recent')],
            ['followers', i18next.t('Followers')],
          ],
        });
      }
    });
    this.WhitelabelQuery();
  }

  @action WhitelabelQuery = () => {
    if (this.featuredProjectsConn) {
      this.featuredProjectsConn.loadMore();
    }
    if (this.projectsConn) {
      this.projectsConn.loadMore();
    }
    if (this.initiativesConn) {
      this.initiativesConn.loadMore();
    }
    if (this.storiesConn) {
      this.storiesConn.loadMore();
    }
    if (this.profilesConn) {
      this.profilesConn.loadMore();
    }
  };
}
